var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 222,
    viewBox: "0 0 222 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "associated_photo"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11123_188525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 222,
    height: 222
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 111,
    cy: 111,
    r: 110.5,
    fill: "#C4C4C4",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11123_188525)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624244",
    x: -49,
    y: -11,
    width: 319,
    height: 319,
    fill: "#E7E8ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M111 128.767C122.821 128.767 134.158 124.038 142.517 115.621C150.876 107.203 155.571 95.7872 155.571 83.8834C155.571 71.9796 150.876 60.5633 142.517 52.146C134.158 43.7288 122.821 39 111 39C99.1789 39 87.842 43.7288 79.4832 52.146C71.1245 60.5633 66.4286 71.9796 66.4286 83.8834C66.4286 95.7872 71.1245 107.203 79.4832 115.621C87.842 124.038 99.1789 128.767 111 128.767ZM95.0866 145.598C60.7875 145.598 33 173.58 33 208.119C33 213.87 37.6313 218.534 43.342 218.534L111 277L178.658 218.534C184.369 218.534 189 213.87 189 208.119C189 173.58 161.213 145.598 126.913 145.598H95.0866Z",
    fill: "#F7F8FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPerson);
export default __webpack_public_path__ + "static/media/avatar-person.37ebfedcd0648a0a40ca0cbf5878e844.svg";
export { ForwardRef as ReactComponent };